import {Detail, Lavorazione, Risorsa} from './_Index';
import {TipoUmTempo} from '../_helpers/TipoUmTempo';
import {Materiale} from './Materiale';
import {ArticoloSchedeTec} from './ArticoloSchedeTec';
import {Contenitore} from "./Contenitore";
import {StatoEnum} from './generated/stato-enum'

export class OrdineKey extends Detail {
  idDocumento: number;
  idRiga: number;
  idRigaLavorazione: number;
}

export class OrdinePKey extends OrdineKey {
  organizzazioneId: number;
}

export class Ordine extends OrdinePKey {
  risorsaId: number;
  lavorazioneId: number;
  dataRegistrazione?: Date;
  numRegistrazione?: number;
  codiceArticolo?: string;
  descArticolo?: string;
  varianteArt?: string;
  quantita: number;
  lotto: number;
  quantitaLavorata: number;
  quantitaLavorataUdM2?: number;
  quantitaScartata: number;
  quantitaScartataUdM2?: number;
  quantitaNonConforme?: number;
  quantitaNonConformeUdM2?: number;
  tempoLav?: string;
  quantitaOrdinataUdM2?: number;
  coeffCar?: number;

  quantitaLavorataWait?: number;
  quantitaScartataWait?: number;
  quantitaNonConformeWait?: number;
  quantitaLavorataUdM2Wait?: number;
  quantitaScartataUdM2Wait?: number;
  quantitaNonConformeUdM2Wait?: number;
  quantitaTrasferimento?: number;
  tempoLavWait?: number;
  fileNameWait?: string;

  qtaRimanente?: number;

  tempoParzialeLav?: string;
  totalWorkingHours?: number;
  partialWorkingHours?: number;
  countWorkingSessions?: number;
  workStartTime?: number;
  lastActionTime?: number;
  lastEventoTime?: number;
  workingTime?: number;

  omacState?: string;
  stato: StatoEnum;
  statoRisorsa?: StatoEnum;
  flgTerminato: boolean;
  statoElimina: number;
  dataTermine: Date;
  commessa?: string;
  umTempo?: TipoUmTempo;
  rifEsterno?: string;

  note: string;
  notaInterna?: string;
  notaFase?: string;
  campiUtente?: string; // JSON {codice: valore} — feature 105, definizioni EntitaCampoUtente.ORDINE_PRODUZIONE

  codBox?: string;
  codMagPrincipale?: string;
  codAreaMagPrinc?: string;

  trasfCodMag?: string;
  trasfCodArea?: string;

  risorsa?: Risorsa;
  lavorazione?: Lavorazione;

  isLastOfRiga?: boolean;
  lastFase?: number;

  isLoading?: boolean;
  onQueue?: boolean;
  //qtaToEsolver?: number;
  erpFound?: boolean;

  rifLottoProdotto?: string;
  rifLottoMateriale?: string;
  boxScarico?: string;
  udM: string;
  udM2?: string;
  rifOdP?: string;
  numFase?: number;

  idOrdVen?: number;
  numRegOrdVen?: number;
  numDocOrdVen?: string;
  rifOrdVen?: string;
  codCliente?: number;
  ragSocialeCliente?: string;
  faseContoLavoro?: number;
  codTerzista?: number;
  ragSocialeTerzista?: string;

  schedeTec?: ArticoloSchedeTec[];
  materiale?: Materiale[];
  contenitori?: Contenitore[];

  idMovimento?: number;
  causaleId?: number;

  cqEsito?: number;
  cqValoreInserito?: number;
  cqOperatore?: number;
  annotazioniNc?: number;

  printerId?: number;
  rifOrdine?: string;
  executedBy?: string;

  coeffUdM2? = () => (this.quantitaOrdinataUdM2 ?? this.quantita) / this.quantita;
}

export class OrdineCreate extends Ordine {
  codiceRisorsa: string;
  codiceLavorazione: string;
  lottoCode?: string;
}
